import { render } from "./LocationSearchBox.vue?vue&type=template&id=4630b6e4&scoped=true"
import script from "./LocationSearchBox.vue?vue&type=script&lang=js"
export * from "./LocationSearchBox.vue?vue&type=script&lang=js"

import "./LocationSearchBox.vue?vue&type=style&index=0&id=4630b6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4630b6e4"]])

export default __exports__